import { Button, Input } from '@components';
import { styled } from '@mui/material';

export const StyledInput = styled(Input)(({ theme }) => ({
  marginTop: theme.spacing(8),
  [theme.breakpoints.up('lg')]: { flex: 1 },
  [theme.breakpoints.down('lg')]: {
    flex: '1 0 100%',
  },
}));

export const MobileLogo = styled('img')(({ theme }) => ({
  width: 140,
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

export const BackButton = styled(Button)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginLeft: `-${theme.spacing(6)}`,
}));

export const StoreButton = styled('img')(({ theme }) => ({
  cursor: 'pointer',
}));